export function simplePlural(name: string): string {
  if (!name) return name;

  // For compound names like "Product: CATEGORY" or "Product:CATEGORY", pluralize only the last word
  const match = name.match(/^(.*[\s:])(\S+)$/);
  const prefix = match ? match[1] : '';
  const last = match ? match[2] : name;
  const lower = last.toLowerCase();

  const isUpper = last === last.toUpperCase() && last !== last.toLowerCase();
  let plural: string;
  if (lower.endsWith('s') || lower.endsWith('x') || lower.endsWith('z') || lower.endsWith('sh') || lower.endsWith('ch')) {
    plural = last + (isUpper ? 'ES' : 'es');
  } else if (lower.endsWith('y') && !/[aeiou]y$/i.test(last)) {
    plural = last.slice(0, -1) + (isUpper ? 'IES' : 'ies');
  } else {
    plural = last + (isUpper ? 'S' : 's');
  }

  return prefix + plural;
}
